import React from "react";
import styled from "styled-components";
import styles from "./VideoChooser.scss";
import ErrorIcon from "@material-ui/icons/Error";

const Container = styled.div`
  background-color: #444;
  color: white;
  padding: 24px;
  position: absolute;
  line-height: 24px;
  top: 30%;
  right: 42%;
  text-align: center;
  width: 16%;
  z-index: 11;
  transition: top 0.5s ease;
`;
class Notifications extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      top: -100,
    };
  }

  showNotifications = () => {
    this.setState({
      top: 16,
    });
  };
  render() {
    return (
      <Container top={this.state.top} id={styles.Notif}>
        <ErrorIcon id={styles.iconError} />
        <br></br>Aucun site n'a été renseigné.
      </Container>
    );
  }
}

export default Notifications;



// WEBPACK FOOTER //
// ./src/pages/patientplaylist/Notifications.jsx